import { useCallback } from 'react';
import { useUiStore } from '../../../stores/uiStore';

interface UseTimelineBlockOptions {
  id: string;
  isSelectedOverride?: boolean;
}

export function useTimelineBlock({
  id,
  isSelectedOverride,
}: UseTimelineBlockOptions) {
  const isSelectedFromStore = useUiStore(
    useCallback((state) => state.selectedToolIds.has(id), [id])
  );
  const isSelected = isSelectedOverride ?? isSelectedFromStore;

  const handleSelectionClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (e.shiftKey) {
        useUiStore.getState().toggleSelection(id);
      } else {
        useUiStore.getState().selectToolBlock(id);
      }
    },
    [id]
  );

  return { isSelected, handleSelectionClick };
}
